import { useState } from 'react';
import config from '../config/config';
import authHeader from '../config/authHeader';

const useFetchLstDocs = () => {
    const [lstDocs, setLstDocs] = useState([]);
    const [countLstDocs, setCountLstDocs] = useState(0);
    const [countExpertises, setCountExpertises] = useState(0);
    const [docDetail, setDocDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fonction pour récupérer la liste complète des documents
    const fetchLstDocs = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDocs`, {
                method: 'GET',
                headers: authHeader(),
            });
            if (!response.ok) {
                throw new Error('Erreur réseau pour récupérer les documents');
            }
            const data = await response.json();
            setLstDocs(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Fonction pour récupérer uniquement le compteur de documents
    const fetchCountLstDocs = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getCountLstDocs`, {
                method: 'GET',
                headers: authHeader(),
            });
            if (!response.ok) {
                throw new Error('Erreur réseau pour récupérer le compteur des documents');
            }
            const { count } = await response.json();
            setCountLstDocs(count || 0);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Fonction pour récupérer uniquement le compteur des expertises
    const fetchCountExpertises = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getCountExpertises`, {
                method: 'GET',
                headers: authHeader(),
            });
            if (!response.ok) {
                throw new Error('Erreur réseau pour récupérer le compteur des Expertises');
            }
            const { count } = await response.json();
            setCountExpertises(count);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchDocsByDeclaUUID = async (uuid) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDocsByDeclaUUID?uuid=${uuid}`, {
                method: 'GET',
                headers: authHeader(),
            });
            if (!response.ok) {
                throw new Error('Erreur réseau pour récupérer les documents par UUID');
            }
            const data = await response.json();
            setLstDocs(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchDocsByTypeAndDeclaUUID = async (uuid, typeDoc) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDocsByTypeAndDeclaUUID?uuid=${uuid}&type=${typeDoc}`, {
                method: 'GET',
                headers: authHeader(),
            });
            if (!response.ok) {
                throw new Error('Erreur réseau pour récupérer l\'expertise par UUID');
            }
            const data = await response.json();
            setLstDocs(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    const createDoc = async (payload) => {
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("LstDocPayload", JSON.stringify(payload));

        console.log(formData);

        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_createDoc`, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Erreur réseau lors de la création du document');
            }

            const data = await response.json();

            setLstDocs((prev) => [...prev, data]);

            return data;
        } catch (err) {
            setError(err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    };


    return {
        lstDocs,
        countLstDocs,
        countExpertises,
        docDetail,
        fetchLstDocs,
        fetchCountLstDocs,
        fetchCountExpertises,
        fetchDocsByDeclaUUID,
        fetchDocsByTypeAndDeclaUUID,
        createDoc,
        loading,
        error,
    };
};

export default useFetchLstDocs;
